export interface GroupsSlice {
  isGroupSaving: boolean;
  isSendingGroupInvitation: boolean;
  setIsGroupSaving: (v: boolean) => void;
  setIsSendingGroupInvitation: (v: boolean) => void;
}

export const createGroupsSlice = (set: any): GroupsSlice => ({
  isGroupSaving: false,
  isSendingGroupInvitation: false,
  setIsGroupSaving: (v) => set({ isGroupSaving: v }),
  setIsSendingGroupInvitation: (v) => set({ isSendingGroupInvitation: v }),
});
